module.exports = ".p-0 {\n  padding: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quote/modals/modal-make-invoice/modal-make-invoice.scss
// module id = ./web/modern/components/quote/modals/modal-make-invoice/modal-make-invoice.scss
// module chunks = 0